<gbc-tile [title]="'add-edit-igrid-system-datapoint.datapoints' | translate">
  @if (datapoints$ | async; as dataPoints) {
    @if (dataPoints?.length) {
      <gbc-table [clickableRows]="true">
        <th gbc-table-header colspan="2">
          {{ 'add-edit-igrid-system-datapoint.data-key' | translate }}
        </th>
        <th gbc-table-header colspan="2">{{ 'app-name' | translate }}</th>
        <th gbc-table-header colspan="2">
          {{ 'add-edit-igrid-system-datapoint.datapoint-type' | translate }}
        </th>
        <th gbc-table-header colspan="2">
          {{ 'add-edit-igrid-system-datapoint.order' | translate }}
        </th>
        <th gbc-table-header colspan="2">
          {{ 'add-edit-igrid-system-datapoint.last-value' | translate }}
        </th>
        <th gbc-table-header colspan="2">
          {{ 'add-edit-igrid-system-datapoint.visible' | translate }}
        </th>
        @if (showDelete) {
          <th gbc-table-header colspan="2">
            {{ 'add-edit-igrid-system-datapoint.actions' | translate }}
          </th>
        }
        @for (datapoint of dataPoints; track datapoint) {
          <tr gbc-table-row (click)="openAddEditDatapointDialog(datapoint)">
            <td gbc-table-cell colspan="2">{{ datapoint.dataKey }}</td>
            <td gbc-table-cell colspan="2" id="name-column">
              {{ datapoint.customName }}
            </td>
            <td gbc-table-cell colspan="2">
              {{ datapoint.dataPointType?.unit | translate }}
            </td>
            <td gbc-table-cell colspan="2">{{ datapoint.order }}</td>
            <td gbc-table-cell colspan="2">
              {{ datapoint.lastValue | number: '1.0-2' | noComma }}
            </td>
            <td gbc-table-cell colspan="2">
              @if (datapoint.visible) {
                <img src="./assets/svgs/green-checked-circle.svg" height="29px" width="29px" alt="green check" />
              }
              @if (!datapoint.visible) {
                <img src="./assets/svgs/remove-circle_filled.svg" height="29px" width="29px" alt="red minus" />
              }
            </td>
            @if (showDelete) {
              <td gbc-table-cell colspan="2">
                <button gbc-icon-button id="delete-datapoint-button" (click)="deleteDatapoint($event, datapoint)">🗑️</button>
              </td>
            }
          </tr>
        }
      </gbc-table>
    } @else {
      <div class="no-sources-label">
        <p>{{ 'add-edit-igrid-system-datapoint.no-data-points' | translate }}</p>
      </div>
    }
    <div class="button-row">
      <button gbc-button id="add-datapoint-button" (click)="openAddEditDatapointDialog()">
        {{ 'add-edit-igrid-system-datapoint.add-new-datapoint' | translate }}
      </button>
    </div>
  }

</gbc-tile>
